function content_margin(mode) {
    //#brand_logo img
    var ran = false;
    if($('body').hasClass('mobileMenuOpened') && $(window).width()<1025) return false;
    if(mode==='resize') {
        $("#brand_logo img,#brand_logo svg").on(
        "transitionend MSTransitionEnd webkitTransitionEnd oTransitionEnd",
            function() {
                calc_content_margin();
                ran=true;
            }
        );
        if(!ran) {
            calc_content_margin();
        }
    }
    else {
        calc_content_margin();
    }
}

function nav_width(mode) {
    if(mode==='resize') {
        var ran = false;
        $('nav#nav-main').css('width','inhreit');
        $("#brand_logo img,#brand_logo svg").on(
        "transitionend MSTransitionEnd webkitTransitionEnd oTransitionEnd",
            function() {
                calc_nav_width();
                ran=true;
            }
        );
        if(!ran) {
            calc_nav_width();
        }
    }
    else {
        if($('body').hasClass('ie')) return false;
        calc_nav_width();
    }
} 

function calc_content_margin() {
    var svgHeight = $('header#top_header #brand_logo').height()+25,
    is_logged = ($('body').hasClass('logged-in') && $(window).width()>1024) ? 0 : 0;
    $('section#content').css('margin-top',svgHeight+is_logged);
}

function calc_nav_width() {
    var navWidth = 0;
    $('nav#nav-main > ul > li').each(function(){
        if($(this).is(':visible')) {
            navWidth += $(this).outerWidth();
        }
    });
    $('nav#nav-main').css('width',navWidth+5);
    $('nav#nav-main ul.productDropdown').css('width',navWidth+1);
}

export {content_margin,nav_width};


// WEBPACK FOOTER //
// ./scripts/misc/utilis.js